export default () => ({
  meActived: false
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/resources/data.js